<div class="sports-header-title-overlay" [style.background]="overlayBgcolor">
    <cc-global-translate class="game-overlay" [key]="'GameOfferings'"></cc-global-translate>
    <div class="brand-logo" (click)="logoClicked()"></div>
    <div class="theme-close-button theme-ex" *ngIf="!hideCloseButton" (click)="closeSportsOverlay()"></div>
</div>
